import styled from 'styled-components';

export const Container = styled.div`
    box-sizing: border-box;
    height: 100vh; /* Fallback для браузеров, которые не поддерживают dvh */
    height: 100dvh;
    overflow: hidden;
    display: flex;
    justify-content: center;
    background-color: ${(props) => props.theme.root.colors.background['01Base']};
`;

export const RoomContainer = styled.div<{ $isFullscreen?: boolean }>`
    height: 100vh; /* Fallback для браузеров, которые не поддерживают dvh */
    height: 100dvh;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    background-color: ${(props) => props.theme.root.colors.background['01Base']};

    &:fullscreen {
        padding: 0;
    }

    @media (max-width: 991px) and (orientation: portrait) {
        padding: var(--mobile-portrait-padding-top) var(--mobile-portrait-padding-right)
            var(--mobile-portrait-padding-bottom) var(--mobile-portrait-padding-left);
    }

    @media (max-width: 991px) and (orientation: landscape) {
        padding: var(--mobile-landscape-padding);
    }
`;

export const EmbeddedContainer = styled.div<{ $withWinPadding: boolean }>`
    box-sizing: border-box;
    height: 100vh;
    height: 100dvh;
    padding-top: ${(props) => (props.$withWinPadding ? '32px' : '0px')};
    background-color: ${(props) => props.theme.root.colors.background['01Base']};
    display: flex;
    justify-content: center;
    align-items: center;

    ${RoomContainer} {
        height: ${(props) => (props.$withWinPadding ? 'calc(100dvh - 32px)' : '100%')};
    }

    ${Container} {
        height: 100%;
        overflow: auto;
        display: flex;
    }
`;

export const Sidebar = styled.aside<{ isOpen: boolean }>`
    position: absolute;
    height: 100vh; /* Fallback для браузеров, которые не поддерживают dvh */
    height: 100dvh;
    top: 0;
    background: black;
    z-index: 1;
    left: ${({ isOpen }) => (isOpen ? 0 : '-300px')};
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
`;

export const SidebarContent = styled.div`
    min-width: 200px;
    padding: 10px;
    box-sizing: border-box;
`;

export const OptionsContainer = styled.div`
    display: grid;
    grid-template-rows: repeat(2, fit-content(120px)) auto;
    gap: 8px;
    padding: 20px;

    label {
        text-align: center;
        margin-left: 0.2rem;
        font-size: 0.9rem;
    }
`;
